import { postMessageToWails } from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { updateSysClientUri } from '@nile/graphql/src/client';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Route, withRouter } from 'react-router-dom';

function SysTrayRoute(props) {
  const { component: Component, layout: Layout, flags, ...rest } = props;
  const [eventData, setEventData] = useState({
    reqType: 'assetUser'
  });
  window.addEventListener('message', (event) => {
    if (event?.data?.origin?.includes('wails')) {
      if (event?.data?.data?.hasOwnProperty('AppAcc')) {
        sessionStorage.setItem(
          'agentProperties',
          JSON.stringify(event?.data?.data)
        );
        setTimeout(() => updateSysClientUri(), 500);
        setEventData((prevState) => ({ ...prevState, ...event?.data?.data }));
      }
    }
  });

  useEffect(() => {
    const agentProp = sessionStorage.getItem('agentProperties');
    window.addEventListener('message', (event) => {
      if (window.frameParentOrigin) {
        if (event?.data?.data?.hasOwnProperty('AppAcc')) {
          sessionStorage.setItem(
            'agentProperties',
            JSON.stringify(event?.data?.data)
          );
          setTimeout(() => updateSysClientUri(), 500);
          setEventData((prevState) => ({ ...prevState, ...event?.data?.data }));
        }
      }
      if (event?.data?.data?.showChatPageEvent) {
        postMessageToWails({
          eventName: 'GET_PROPERTIES'
        });
      }
    });
    postMessageToWails({
      eventName: 'GET_PROPERTIES'
    });
    if (!isEmpty(agentProp)) {
      setEventData((prevState) => ({ ...prevState, ...JSON.parse(agentProp) }));
    }
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout
          routeComponent={<Component eventData={eventData} {...props} />}
        />
      )}
    />
  );
}
export default withRouter(SysTrayRoute);
